import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AlertColor } from "@mui/material";
import {
  AddressResponse,
  PlanDetailResponseAvailableDaysEnum,
  PlanOptionResponseMealTypeListEnum,
} from "../openapi/client";

export interface SaleState {
  alert: IAlert;
  partner?: string;
  partnerName?: string;
  plan?: string;
  planOptionId?: string;
  selection?: PlanDetailResponseAvailableDaysEnum[];
  mealType?: string;
  deliveryDays?: number;
  startDate?: string;
  zone?: number;
  deliveryFee?: number;
  totalFee?: number;
  address?: AddressResponse;
  paymentProceed?: boolean;
  deliveryNote?: string;
  deliveryInstruction?: string;
  deliveryMessage?: string;
}

export interface IAlert {
  show: boolean;
  title?: string;
  text?: string;
  severity?: AlertColor;
}

const initialState: SaleState = {
  alert: { show: false, title: "", text: "" },
  partner: "",
  partnerName: "",
  plan: "",
  planOptionId: undefined,
  selection: undefined,
  mealType: undefined,
  deliveryDays: undefined,
  startDate: "",
  zone: undefined,
  deliveryFee: undefined,
  totalFee: undefined,
  address: undefined,
  paymentProceed: undefined,
  deliveryNote: undefined,
  deliveryInstruction: undefined,
  deliveryMessage: undefined,
};

export const saleSlice = createSlice({
  name: "sale",
  initialState,
  reducers: {
    setSelection: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        alert: { show: false, title: "", text: "" },
        ...action.payload,
      };
    },
    resetSelection: (state) => {
      return {
        ...state,
        ...initialState,
      };
    },
    setAlert: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        alert: action.payload,
      };
    },
    resetAlert: (state) => {
      return {
        ...state,
        alert: { show: false, title: "", text: "" },
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelection, resetSelection, setAlert, resetAlert } = saleSlice.actions;

export default saleSlice.reducer;
